export const Instagram = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8941 8.78125C12.9558 8.78125 8.86414 12.8024 8.86414 17.8112C8.86414 22.82 12.8853 26.8412 17.8941 26.8412C22.9029 26.8412 26.9241 22.7495 26.9241 17.8112C26.9241 12.873 22.8324 8.78125 17.8941 8.78125ZM17.8941 23.5961C14.7195 23.5961 12.1093 20.9858 12.1093 17.8112C12.1093 14.6366 14.7195 12.0264 17.8941 12.0264C21.0687 12.0264 23.679 14.6366 23.679 17.8112C23.679 20.9858 21.0687 23.5961 17.8941 23.5961Z"
        fill="hsl(var(--fc1), 50%)"
      />
      <path
        d="M27.2768 10.6155C28.4067 10.6155 29.3227 9.69955 29.3227 8.56966C29.3227 7.43976 28.4067 6.5238 27.2768 6.5238C26.1469 6.5238 25.231 7.43976 25.231 8.56966C25.231 9.69955 26.1469 10.6155 27.2768 10.6155Z"
        fill="hsl(var(--fc1), 50%)"
      />
      <path
        d="M32.5679 3.27865C30.7337 1.37388 28.1234 0.38623 25.1605 0.38623H10.6278C4.49027 0.38623 0.39856 4.47794 0.39856 10.6155V25.0776C0.39856 28.1111 1.38621 30.7213 3.36152 32.6261C5.26628 34.4603 7.80597 35.3774 10.6984 35.3774H25.0899C28.1234 35.3774 30.6631 34.3898 32.4973 32.6261C34.4021 30.7919 35.3897 28.1816 35.3897 25.1481V10.6155C35.3897 7.65254 34.4021 5.11286 32.5679 3.27865ZM32.2857 25.1481C32.2857 27.3351 31.5097 29.0988 30.2398 30.298C28.97 31.4973 27.2063 32.1323 25.0899 32.1323H10.6984C8.58198 32.1323 6.81831 31.4973 5.54847 30.298C4.27863 29.0282 3.64371 27.2645 3.64371 25.0776V10.6155C3.64371 8.4991 4.27863 6.73544 5.54847 5.4656C6.74776 4.2663 8.58198 3.63138 10.6984 3.63138H25.231C27.3474 3.63138 29.1111 4.2663 30.3809 5.53614C31.5802 6.80598 32.2857 8.56965 32.2857 10.6155V25.1481Z"
        fill="hsl(var(--fc1), 50%)"
      />
    </svg>
  );
};
